import { ACCOMMODATIONS } from "@/lib/constants";
import { useGuestyListings } from "@/components/LiveAvailability";

const LISTING_MATCH = { "bet-cabin": "cabin", glamping: "tent", domes: "dome" };

export const useLiveAccommodations = () => {
  const { listings } = useGuestyListings();

  const liveInfo = (acc) => {
    const key = LISTING_MATCH[acc.id];
    if (!key || !listings.length) return acc;
    const matched = listings.filter((l) =>
      `${l.title || ""} ${l.nickname || ""} ${l.property_type || ""}`.toLowerCase().includes(key)
    );
    if (!matched.length) return acc;
    const max = Math.max(...matched.map((l) => l.accommodates || 0));
    return {
      ...acc,
      capacity: max ? `Up to ${max} guests` : acc.capacity,
      name: acc.id === "bet-cabin" ? matched[0].title || acc.name : acc.name,
    };
  };

  const cabinListing =
    listings.find((l) =>
      `${l.title || ""} ${l.nickname || ""} ${l.property_type || ""}`.toLowerCase().includes("cabin")
    ) || null;

  return { accommodations: ACCOMMODATIONS.map(liveInfo), cabinListing };
};
